import { useEffect, useState, type JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, type Flow } from '../api.js';
import { useActiveProfileId } from '../active-profile.js';
import { Topbar } from './AdminLayout.js';

export function FlowsList(): JSX.Element {
  const nav = useNavigate();
  const [items, setItems] = useState<Flow[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [activeProfileId] = useActiveProfileId();

  useEffect(() => {
    setItems(null);
    api.listFlows().then(setItems).catch((e: Error) => setErr(e.message));
  }, [activeProfileId]);

  return (
    <>
      <Topbar
        title="Флоу"
        actions={
          <button className="btn btn-primary btn-sm" onClick={() => nav('/admin/flows/new')}>
            + Новый флоу
          </button>
        }
      />
      <div style={{ padding: '24px 28px', flex: 1, overflowY: 'auto' }}>
        <div style={{ fontSize: 13, color: 'var(--fg-subtle)', marginBottom: 14, maxWidth: 680 }}>
          Флоу — цепочка действий после успешной оплаты (письмо, уведомления, билет…). Создай флоу
          и выбери его на продукте. Продукт без флоу работает по дефолтному сценарию.
        </div>
        {err && (
          <div
            className="card"
            style={{ padding: 14, marginBottom: 14, color: 'var(--danger-fg)', background: 'var(--danger-subtle-bg)' }}
          >
            {err}
          </div>
        )}
        <div className="card">
          <table className="tbl">
            <thead>
              <tr>
                <th>Название</th>
                <th style={{ textAlign: 'right' }}>Шагов</th>
                <th style={{ textAlign: 'right' }}>Продуктов</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {items?.map((f) => (
                <tr key={f.id} onClick={() => nav(`/admin/flows/${f.id}`)}>
                  <td>
                    <div style={{ fontWeight: 500 }}><bdi>{f.name}</bdi></div>
                  </td>
                  <td className="num" style={{ textAlign: 'right' }}>{f._count?.steps ?? 0}</td>
                  <td className="num" style={{ textAlign: 'right' }}>{f._count?.products ?? 0}</td>
                  <td>
                    <span className={'chip no-dot ' + (f.isActive ? 'chip-ok' : 'chip-neutral')}>
                      {f.isActive ? 'активен' : 'выключен'}
                    </span>
                  </td>
                </tr>
              ))}
              {items && items.length === 0 && (
                <tr className="no-hover">
                  <td colSpan={4} style={{ textAlign: 'center', padding: 32, color: 'var(--fg-subtle)' }}>
                    Флоу пока нет
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
